export const errorMessages = {
  en: {
    required: field => `Field ${field} is required.`,
    minLength: (field, minCount) => `Number of ${field} must be ${minCount[0]} or more.`,
    maxLength: (field, maxCount) => `Number of ${field} must be ${maxCount[0]} or less.`,
    min: (field, { length }) => `At least ${length} characters must be entered in the ${field} field.`,
    max: (field, { length }) => `Maximum ${length} characters must be entered in the ${field} field.`,
    decimal: field => ` The ${field} field may only contain numeric characters`,
    iframe: field => `Please enter valid ${field} code`,
    soundcloudIframe: field => `Entered ${field} should be valid iframe code from soundcloud.`,
    nullableEmail: field => `Please enter valid ${field} address`,
    nullableTwitter: field => `Please enter valid ${field} username or profile url`,
    nullableFacebook: field => `Please enter valid ${field} nickname`,
    nullableInstagram: field => `Please enter valid ${field} nickname`,
    nullableYoutube: field => `Please enter valid ${field} nickname`,
    nullableTiktok: field => `Please enter valid ${field} nickname`,
    waitUpload: () => 'File upload is in progress.',
    url: () => 'Please enter a valid URL',
    rel: () => 'Please enter a valid REL',
    announcementNumber: () => 'Please enter a valid Announcement Number',
    absoluteUrl: () => 'Please enter a valid URL (example: http://www...)',
    relativeUrl: () => 'Please enter a valid URL (example: /test/news-12345)',
    minValue: (field, { min: minVal }) => `The ${field} could not be less than ${minVal}`,
    hasCoverImage: () => 'Please upload cover image',
    isUploading: field => `A/an ${field} files are currently uploading. Please wait for all files to upload.`,
    validCropSettings: () => 'Please rearrange Photo Crop sizes.',
    totalContentCountLess: () => 'Total number of content cannot be less than the number of content.',
    hexColor: () => 'The color code you entered is invalid.',
  },
  tr: {
    required: field => `${field} alanı zorunludur.`,
    minLength: (field, minCount) => `En az ${minCount[0]} adet ${field} seçilmelidir.`,
    maxLength: (field, maxCount) => `En fazla ${maxCount[0]} adet ${field} seçilmelidir.`,
    min: (field, { length }) => `${field} alanına en az ${length} karakter girilmelidir.`,
    max: (field, { length }) => `${field} alanına en fazla ${length} karakter girilmelidir.`,
    decimal: field => `${field} alanı sadece sayı içerebilir.`,
    iframe: field => `Lütfen geçerli ${field} kod giriniz.`,
    soundcloudIframe: field => `Girdiğiniz ${field} geçerli bir soundcloud iframe kodu olmalıdır.`,
    nullableEmail: field => `Lütfen geçerli ${field} adres giriniz`,
    nullableTwitter: field => `Lütfen geçerli ${field} kullanıcı adı veya profil adresi giriniz`,
    nullableFacebook: field => `Lütfen geçerli ${field} kullanıcı adı giriniz`,
    nullableInstagram: field => `Lütfen geçerli ${field} kullanıcı adı giriniz`,
    nullableYoutube: field => `Lütfen geçerli ${field} kullanıcı adı giriniz`,
    nullableTiktok: field => `Lütfen geçerli ${field} kullanıcı adı giriniz`,
    waitUpload: () => 'Dosya yükleme işlemi devam ediyor.',
    url: () => 'Lütfen geçerli bir URL giriniz',
    rel: () => 'Lütfen geçerli bir REL giriniz',
    announcementNumber: () => 'Lütfen geçerli bir basın ilan no giriniz',
    absoluteUrl: () => 'Lütfen geçerli bir URL giriniz (örnek: http://www...)',
    relativeUrl: () => 'Lütfen geçerli bir URL Adresi giriniz (örnek: /deneme/haber-12345)',
    minValue: (field, { min: minVal }) => `${field} ${minVal}'den küçük olamaz`,
    hasCoverImage: () => 'Lütfen kapak fotoğrafı yükleyiniz.',
    isUploading: field => `Şu anda ${field} dosyası yükleniyor. Lütfen tüm dosyaların yüklenmesini bekleyin.`,
    validCropSettings: () => 'Lütfen Fotoğraf Kırpma boyutlarını tekrardan düzenleyin.',
    totalContentCountLess: () => 'Toplam içerik sayısı, içerik sayısından küçük olamaz.',
    hexColor: () => 'Girdiğiniz renk kodu geçersizdir.',
  },
};
